import { FirebaseApp, initializeApp }  from 'firebase/app';
import { Firestore, getFirestore, collection, getDoc, getDocs, setDoc, updateDoc, doc, deleteDoc, increment } from 'firebase/firestore';
import { Auth, getAuth, GoogleAuthProvider, signInWithPopup, User, setPersistence, browserSessionPersistence } from "firebase/auth";
import { FirebaseStorage, deleteObject, getStorage, ref, uploadBytes } from "firebase/storage";

const FIREBASE_CONFIG = {
	apiKey: "AIzaSyAeos5MJfnT8CWGWX10tSS9_NyYkgLFLbc",
	authDomain: "gamestolearnenglish-fb.firebaseapp.com",
	databaseURL: "https://gamestolearnenglish-fb.firebaseio.com",
	projectId: "gamestolearnenglish-fb",
	storageBucket: "gamestolearnenglish-fb.appspot.com",
	messagingSenderId: "940750443735",
	appId: "1:940750443735:web:5e4621b9f37842ac974c92",
	measurementId: "G-17E5QKFXFM"
};

export default class FBInterface{
	
	private myReq:XMLHttpRequest=new XMLHttpRequest();
	private fbApp:FirebaseApp=initializeApp(FIREBASE_CONFIG);
	private firestoreDb:Firestore=getFirestore(this.fbApp);
	private firebaseStorage:FirebaseStorage=getStorage(this.fbApp);
	private auth:Auth=getAuth(this.fbApp);

	setInterfacePersistence(){
		setPersistence(this.auth, browserSessionPersistence);
	}

	addAuthListener(callback:Function){
		if(this.auth!==null){
			this.auth.onAuthStateChanged(function(user:User|null) {
				callback(user);
			});
		}
	}

	signIn(callback:Function){
		var provider = new GoogleAuthProvider();
		if(this.auth!==null){
			signInWithPopup(this.auth, provider)
			.then(() => {
				callback('');
			})
			.catch((error) => {
				callback(error.message);
			});
		}
	}

	signOut(callback:Function){
		if(this.auth!==null){
			this.auth.signOut()
			.then(function() {
				callback('');
			})
			.catch(function(error) {
				callback(error.message)
			});
		}
	}

	getOneDoc(docPath:string,callback:Function){
		getDoc(doc(this.firestoreDb,docPath))
		.then((myDoc)=>{
			if(myDoc.exists()){
				callback('',myDoc.data());
			}else{
				callback('',{tasks:[]});
			}
		})
		.catch(()=>{
			callback('err',{tasks:[]});
		})
	}

	getAllDocs(docsPath:string,callback:Function){
		getDocs(collection(this.firestoreDb,docsPath))
		.then((querySnapshot)=>{
			callback(querySnapshot);
		})
		.catch(()=>{
			callback(null);
		})
	}

	deleteDocuments(deleteList:string[],callback:Function){
		if(deleteList.length===0)callback(true);//no docs to delete
		let numReturned=0;
		let numDeleted=0;
		deleteList.forEach((myDoc)=>{
			this.deleteDocument(myDoc,(outcome:boolean)=>{
				numReturned+=1;
				if(outcome)numDeleted+=1;
				if(numReturned===deleteList.length){
					callback(numDeleted===deleteList.length);
				}
			});
		});
	}	

	deleteDocument(docPath:string, callback:Function){
		deleteDoc(doc(this.firestoreDb,docPath))
		.then(()=>{callback(true);})
		.catch(()=>{callback(false);})
	}

	setDocument(docPath:string, createData:{}, callback:Function){
		setDoc(doc(this.firestoreDb,docPath),createData)
		.then(()=>{
			callback(0);
		})
		.catch(()=>{
			callback(1);
		})
	}

	getJson(jsonPath:string, callback:Function){
		this.myReq.onreadystatechange=function(){
			if(this.readyState===4){
				if (this.status === 200) {
					callback(0,this.responseText);
				} else {
					callback(1,'');
				}
			}
		};
		this.myReq.open("GET", jsonPath, true);
		this.myReq.send();
	}

	uploadJson(jsonPath:string, jsonBlob:Blob, callback:Function){
		uploadBytes(ref(this.firebaseStorage,jsonPath), jsonBlob)
		.then(() => {
			callback(0);
		})
		.catch((err)=>{
			console.log(err)
			callback(1);
		})
	}

	deleteJson(jsonPath:string, callback:Function){
		deleteObject(ref(this.firebaseStorage,jsonPath))
		.then(() => {
			callback(0);
		})
		.catch((err)=>{
			console.log(err)
			callback(1);
		})
	}

	incrementCounter(docPath:string, callback:Function){
		updateDoc(doc(this.firestoreDb,docPath),{
			id: increment(1)
		})
		.then(() => {
			callback(0);
		})
		.catch(()=>{
			callback(1);
		})
	  }
}
